import axios from 'axios';
import Vue from 'vue';
const moment = require('moment');
Vue.prototype.$permission = {};
const token = [];
export default {
	data(){
		return {
			test:'test',
			token: {},
		}
	},
	methods:{
		config(key) {
			let config = {
				app: {
					// name: 'AxCap247',
					name: 'Anlyst',
					company: {
						// name: 'Axis Capital Markets Limited',
						name: 'Anlyst',
						// short_name: 'AxCap247',
						short_name: 'Anlyst',
						email: 'testing@klixtech.com'
					}
				}
			};
			key.split('.').forEach(k => config = config[k])
			return config;
		},
		get_baseURL(of='api'){
			if(of=='api'){
				return process.env.VUE_APP_API_URL;
			}
			else if(of=='root'){
				return process.env.VUE_APP_ROOT_URL;
			}
		},
		cancelRequest(index){
			token[index].request.cancel("Cancelled by new request..")
		},
		async call_axios(uri,method='get',data={}, cancelOld = true){
			try {
				var url = new URL(this.get_baseURL()+uri);
				url.searchParams.set('api_token', window.localStorage.getItem('auth_token'));
				//console.log(uri, token[url.pathname])
				if (token[url.pathname] && token[url.pathname].done === null && cancelOld){
					this.cancelRequest(url.pathname);
				}
				const request = axios.CancelToken.source();
				token[url.pathname] = { done: null, request };
				const res = await axios({
		              url: url,
		              method: method,
		              data:data,
		              timeout: 1800000,
		              headers: {
		                  'Content-Type': 'application/json',
		                  'access-token': '7403f0291437c47e589fdd0445860f95'
					  },
					cancelToken: token[url.pathname].request.token
		          }).then(response => {
		          		if(response.code != 'file'){
							token[response.config.url.pathname].done = true;
								if (response.data)
									return { response : response.data };
								else this.$toasted.error(response.error, { duration: 1000 });
						}else{
					    	var str = response.data.result;
            				var anchor = $('.vcard-hyperlink');
            				var maxSizeForBase64 = 1048576; //1024 * 1024
				            var windowUrl = window.URL || window.webkitURL;
				            if (str.length > maxSizeForBase64 && typeof windowUrl.createObjectURL === 'function') {
				                var blob = new Blob([result.response], { type: 'text/bin' });
				                var url = windowUrl.createObjectURL(blob);
				                anchor.prop('href', url);
				                anchor.prop('download', id+'.bin');
				                anchor.get(0).click();
				                windowUrl.revokeObjectURL(url);
				            }else {
				                //use base64 encoding when less than set limit or file API is not available
				                anchor.attr({
				                    href: 'data:text/plain;base64,'+FormatUtils.utf8toBase64(result.response),
				                    download: id+'.bin',
				                });
				                anchor.get(0).click();
				            }
					    }
				  })
				  .catch(error => {
					  if (axios.isCancel(error)) {
						  //console.log("cancelled: ", token[url.pathname])
						  return false;
						  //this.call_axios(uri, method, data);						  
					  }
					  /* window.localStorage.setItem('auth_token', false);
					  window.localStorage.setItem('auth_user', false);
		          	  window.location.href = this.get_baseURL('root')+'#/login';   */ 
					//   this.$toasted.error("Something went wrong! please try again later.", { duration: 1000 }); 
					this.$toasted.error("Your session has expired! please log in again.", { duration: 1000 }); 

					//   logout() {
						window.localStorage.setItem('auth_token', false);
						window.localStorage.setItem('auth_user', false);
						this.$router.push('/login');
					//   }  
				  });	
				return res || { response: {} };	              
		    }
			catch (err) {
				/* window.localStorage.setItem('auth_token', false);	
				window.localStorage.setItem('auth_user', false);	
				window.location.href = this.get_baseURL('root')+'#/login';   */
			} 

			window.localStorage.setItem('auth_token', false);
			window.localStorage.setItem('auth_user', false);
			window.location.href = this.get_baseURL('root') + '#/login'; 
			//this.$toasted.error("Something went wrong! please try again later.", { duration: 1000 });
		},
		duplicate(o) {
		    if (o === null) return null;

		    var output, v, key;
		    output = Array.isArray(o) ? [] : {};
		    for (key in o) {
		        v = o[key];
		        output[key] = (typeof v === "object") ? this.duplicate(v) : v;
		    }
		    return output;
		},
		formatNumber(num) {
		  return Number(Number.isInteger(num) ? num : Number(num).toFixed(4));
		},
		validate(rules){
			var that = this;
			var error = false;
			const errorSpan = document.createElement('span');
			//console.log(errorSpan);
			errorSpan.classList.add('error');

			Object.keys(rules).forEach(function(rule) {
			    Object.keys(rules[rule]).forEach(function(key){
			    	var errorSpanCopy = errorSpan;
			    	switch(key) {
						case 'required':
							//if(that.formInput[rule]){
							errorSpanCopy.innerHTML = "required "+rule.replace("_", " ");
							if(that.$refs[rule].hasOwnProperty('$el'))
								that.$refs[rule].$el.appendChild(errorSpanCopy);
							else that.$refs[rule].appendChild(errorSpanCopy);
							//}
						break;
						default:
							// code block
					} 
			    });
			});
			//this.$refs
			return error;
			'<span class="error">required</span>';
		},toCapitalize(str){
			return str.charAt(0).toUpperCase() + str.slice(1)
		},can_access(module,access){
			if (Object.entries(Vue.prototype.$permission).length === 0){
				this.get_authorize();
			}
			if (Vue.prototype.$permission.hasOwnProperty(module) && Vue.prototype.$permission[module].hasOwnProperty(access))
				return Vue.prototype.$permission[module][access];
			
			/* window.localStorage.setItem('auth_token', false);
			window.localStorage.setItem('auth_user', false);
			window.location.href = this.get_baseURL('root') + '#/login';  */
		},can_view_field(module,field){
			return true;
			if (Object.entries(Vue.prototype.$permission).length === 0){
				this.get_authorize();
			}
			if (Vue.prototype.$permission.hasOwnProperty(module) && Vue.prototype.$permission[module]['fields'])
				return Vue.prototype.$permission[module]['fields'].includes(field);
			
			/* window.localStorage.setItem('auth_token', false);
			window.localStorage.setItem('auth_user', false);
			window.location.href = this.get_baseURL('root') + '#/login';  */
		},async get_authorize(){
			if(window.localStorage.getItem('auth_token') && Object.entries(Vue.prototype.$permission).length === 0){
				const res = await this.call_axios('get_permissions');
				if (res.response.data)
					return Vue.prototype.$permission = res.response.data.result;
			}return Vue.prototype.$permission
		},getLastWorkingDate(){
			let workday = moment();
			let day = workday.day();
			let diff = 1;  // returns yesterday
			if (day == 0 || day == 1){  // is Sunday or Monday
				diff = day + 2;  // returns Friday
			}
			return workday.subtract(diff, 'days').format('DD-MM-YYYY');
		}
	}
}